import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AuthService } from '@app/shared/services/auth.service';
import { EventsService } from '@app/shared/services/events.service';
import { MunicipalityService } from '@app/shared/services/api/municipality.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { environment } from '@env/environment';
import { MapStoreMunicipality } from '@app/shared/models/municipality/Municipality';
import { PermissionCode } from './../shared/enums';
import { MfeBaseComponent } from '@app/shared/components/mfe-base/mfe-base.component';

@Component({
  selector: 'app-energiemonitor',
  templateUrl: './energiemonitor.component.html',
  styleUrls: ['./energiemonitor.component.scss'],
})
export class EnergieMonitorComponent extends MfeBaseComponent implements OnInit, OnDestroy {
  protected readonly mfeUrl = new URL(environment.producerKPIUrl);
  protected readonly element = 'app-energiemonitor-lite';
  protected readonly parentElement = 'app-energiemonitor-content';
  protected readonly routePath = '/energiemonitorv2';
  protected readonly navigateEventName = 'navigateToEnergieMonitor';
  protected mfeSubscription$ = new Subscription();
  private readonly navigateHomeHandler = (_: unknown) => this.navigateToHome();
  protected readonly pagePermission = PermissionCode.ENERGY_MONITOR;
  protected readonly changedEventName = 'energiemonitor_MunicipalityChangedEvent';

  get environment() {
    return environment;
  }
  constructor(
    sanitizer: DomSanitizer,
    httpClient: HttpClient,
    overlayLoaderService: OverlayLoaderService,
    municipalityService: MunicipalityService,
    userMunicipalitiesService: UserMunicipalitiesService,
    authService: AuthService,
    eventsService: EventsService,
    router: Router,
  ) {
    super(sanitizer, httpClient, overlayLoaderService, municipalityService, userMunicipalitiesService, authService, eventsService, router);
  }

  protected getAdditionalEventPayload(_municipality: MapStoreMunicipality): Record<string, any> {
    return {
      hasEditPermission: !!this.authService.permissions.ENERGY_MONITOR_EDIT,
      isTeaserMode: !!this.authService.permissions.ENERGY_MONITOR.teaser,
    };
  }
}
